import * as CONST from "../../../app/constants"
import { applicationTypeFromLicenceSubType, isChangeRequestTypeApplication, isMortgageMainAgentTypeApplication, isRenewalTypeApplication } from "../../slice/applicationsUtils";
import { 
    brokerConfirmationInformation,
    brokerConfirmationInformationForRenewal,
    brokerCriminalRecordCheckInformation,
    brokerCriminalRecordCheckInformationForRenewal,
    brokerEducationContinuationRequirementInformationForRenewal,
    brokerEducationRequirementInformation,
    brokerQualificiationsInformationForRenewal,
    brokerRegulatoryInformation,
    currentMortgageBrokerLicenceInformation,
    parseAIRInformationForRenewal,
    parseAppointedAgentInformation,
    parseAppointedAgentInformationForRenewal,
    parseCompanyTypeInformationForRenewal,
    parseConfirmationInformation,
    parseConfirmationInformationForRenewal,
    parseCriminalRecordsCheckInformation,
    parseCriminalRecordsCheckInformationForRenewal,
    parseFinancialRecordsInformation,
    parseFinancialRecordsInformationForRenewal,
    parseFiscalYearInformation,
    parseFiscalYearInformationForRenewal,
    parseInsuranceInformation,
    parseInsuranceInformationForRenewal,
    parseMortgageApplicantInformation,
    parseMortgageApplicantInformationForRenewal,
    parseMortgageBrokerageChangeRequestInformation,
    parseMortgageBrokerageChangeRequestAgentEmail,
    parsePrincipalBrokerInformation,
    parsePrincipalBrokerInformationForRenewal,
    parseServiceAddressInformation,
    parseServiceAddressInformationForRenewal,
    parseComplianceOfficerConfirmationInformation,
    currentIndividualPrincipalBrokerInformation,
    parseUpdatedDocumentsInformation,
    isHavingUpdatedDocuments,
    getUpdatedDocuemntsWithReviewData,
    parseCancelLicenceInformationMap,
    // parseNotAddedDocumentsInformation
} from "./bltReviewMortgageApplication";
import { isReviewDataNeeded } from "../bltReviewSelector";

export function mortgageReviewDataDetails(
    queueItem, 
    primaryAgencyApplication, 
    currentAgentApplication) 
{
    let sectionsByOrder = []; 
    let businessLicenceData = {};
    const commonSections =  ["internalNotesMap","decisionMap"];

    if(queueItem?.applicationStatus === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT) {

        businessLicenceData = currentAgentApplication?.businessLicenceData;
        sectionsByOrder = ["applicantInformationMap"];
    } else if(queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION) {
        businessLicenceData = primaryAgencyApplication.application?.businessLicenceData

        sectionsByOrder = [
            "applicantInformationMap",
            "principalBrokerInformationMap",
            "financialRecordsInformationMap",
            "appointedAgentInformationMap",
            "serviceAddressInformationMap",
            "fiscalYearInformationMap",
            "criminalRecordsCheckInformationMap",
            "insuranceInformationMap",
            "confirmationInformationMap"
        ]
    } else if(queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION) {
        businessLicenceData = primaryAgencyApplication.application?.businessLicenceData

        sectionsByOrder = [
            "applicantInformationMap",
            "principalBrokerInformationMap",
            "airInformationMap",
            "companyTypeInformationMap",
            "financialRecordsInformationMap",
            "appointedAgentInformationMap",
            "serviceAddressInformationMap",
            "fiscalYearInformationMap",
            "criminalRecordsCheckInformationMap",
            "insuranceInformationMap",
            "confirmationInformationMap",
        ]
    } else if(queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION
            || queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION) 
    { 
        businessLicenceData = currentAgentApplication?.businessLicenceData

        sectionsByOrder = [
            "applicantInformationMap",
            "brokerLicenceHistoryMap",
            "brokerEducationRequirementMap",
            "brokerCriminalRecordCheckMap",
            "brokerRegulatoryInformationMap",
            "brokerConfirmationInformationMap",
        ]
    } else if(queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION
                || queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION) 
    { 
        businessLicenceData = primaryAgencyApplication.application?.businessLicenceData

        sectionsByOrder = [
            "applicantInformationMap",
            "brokerLicenceHistoryMap",
            // "brokerEducationRequirementMap",
            // "brokerCriminalRecordCheckMap",
            // "brokerRegulatoryInformationMap",
            "confirmationInformationMap",
        ]
    } else if(queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION
        || queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION) 
    { 
        businessLicenceData = primaryAgencyApplication.application?.businessLicenceData

        sectionsByOrder = [
            "applicantInformationMap",
            "brokerCriminalRecordCheckMap",
            "confirmationInformationMap",
        ]
    } else if(queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION
                || queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION
                )
    {
        businessLicenceData = currentAgentApplication?.businessLicenceData

        sectionsByOrder = [
            "applicantInformationMap",
            "brokerQualificationInformationMap",
            "brokerCriminalRecordCheckMap",
            "brokerEducationRequirementMap",
            "brokerConfirmationInformationMap",
        ]
    } 
    else if(queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION)
    { 
        businessLicenceData = currentAgentApplication?.businessLicenceData

        sectionsByOrder = [
            "applicantInformationMap",
            "brokerQualificationInformationMap",
            "brokerCriminalRecordCheckMap",
            "brokerEducationRequirementMap",
            "brokerConfirmationInformationMap",
        ]
    } 
    else if(queueItem?.licencingSubType === 
            CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION) { 
        businessLicenceData = currentAgentApplication?.businessLicenceData

        sectionsByOrder = [
            "applicantInformationMap",
            "brokerLicenceHistoryMap",
            "brokerEducationRequirementMap",
            "brokerCriminalRecordCheckMap",
            "brokerConfirmationInformationMap",
        ]
    } else if(queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION) {
        businessLicenceData = primaryAgencyApplication.application?.businessLicenceData
        sectionsByOrder = [
            "changeRequestDetailsMap",
            "changeRequestNewAgentEmailMap",
        ]
    }

    if (queueItem?.applicationStatus !== CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT && isHavingUpdatedDocuments(queueItem)) {
       if(queueItem?.licenceStatus === CONST.LICENCE_STATUS_ACTIVE) {
            //Ignoring other sections for ACTIVE licence status
            sectionsByOrder = ["updatedDocumentsMap", ...commonSections];
        }
        else {
            sectionsByOrder = [...sectionsByOrder, "updatedDocumentsMap", ...commonSections];
        }
    } else {
        sectionsByOrder = [...sectionsByOrder, ...commonSections];
    }

    return {businessLicenceData, sectionsByOrder};
}

export function bltMortgageBrokerageReviewData(brokerageApplication,brokerageApplicationArchive) {
    const applicationItem = brokerageApplication.businessLicenceData
    const { documents } = brokerageApplication

    if(isReviewDataNeeded(applicationItem)) 
    {
        const isRenewal = isRenewalTypeApplication(brokerageApplication)
        
        let applicantInformationMap = [{}]
        let principalBrokerInformationMap = [{}]
        let financialRecordsInformationMap = [{}]
        let appointedAgentInformationMap = [{}]
        let serviceAddressInformationMap = [{}]
        let fiscalYearInformationMap = [{}]
        let insuranceInformationMap = [{}]
        let confirmationInformationMap = [{}]
        let criminalRecordsCheckInformationMap = [{}]
        let companyTypeInformationMap = [{}]
        let airInformationMap = [{}]
        let changeRequestDetailsMap = [{}]
        let changeRequestNewAgentEmailMap = [{}]
        
        if(isRenewal) {
            const applicationItemArchive = brokerageApplicationArchive?.businessLicenceData
            applicantInformationMap = parseMortgageApplicantInformationForRenewal(applicationItem,applicationItemArchive)
            principalBrokerInformationMap = parsePrincipalBrokerInformationForRenewal(applicationItem, applicationItemArchive)
            financialRecordsInformationMap = parseFinancialRecordsInformationForRenewal(applicationItem, applicationItemArchive)
            appointedAgentInformationMap = parseAppointedAgentInformationForRenewal(applicationItem, applicationItemArchive)
            serviceAddressInformationMap = parseServiceAddressInformationForRenewal(applicationItem, applicationItemArchive)
            fiscalYearInformationMap = parseFiscalYearInformationForRenewal(applicationItem, applicationItemArchive)
            insuranceInformationMap = parseInsuranceInformationForRenewal(applicationItem, documents)
            confirmationInformationMap = parseConfirmationInformationForRenewal(applicationItem)
            criminalRecordsCheckInformationMap = parseCriminalRecordsCheckInformationForRenewal(applicationItem,documents, brokerageApplicationArchive)
            companyTypeInformationMap = parseCompanyTypeInformationForRenewal(applicationItem, applicationItemArchive)
            airInformationMap = parseAIRInformationForRenewal(applicationItem, documents)
        } else {
            if(!isChangeRequestTypeApplication(brokerageApplication)) {
                applicantInformationMap = parseMortgageApplicantInformation(applicationItem)
                principalBrokerInformationMap = parsePrincipalBrokerInformation(applicationItem)
                financialRecordsInformationMap = parseFinancialRecordsInformation(applicationItem)
                appointedAgentInformationMap = parseAppointedAgentInformation(applicationItem)
                serviceAddressInformationMap = parseServiceAddressInformation(applicationItem)
                fiscalYearInformationMap = parseFiscalYearInformation(applicationItem)
                insuranceInformationMap = parseInsuranceInformation(applicationItem, documents)
                confirmationInformationMap = parseConfirmationInformation(applicationItem)
                criminalRecordsCheckInformationMap = parseCriminalRecordsCheckInformation(applicationItem,documents)
            } else {
                changeRequestDetailsMap = parseMortgageBrokerageChangeRequestInformation(applicationItem)
                changeRequestNewAgentEmailMap = parseMortgageBrokerageChangeRequestAgentEmail(applicationItem)
            }
        }


        const decisionMap = [{
            adminDecision : "",
            review : ""
        }]
        const internalNotesMap = [{
            internalNotes : applicationItem.internalNotes,
            review : (applicationItem.internalNotes?.length > 0) ? "complete" : "" 
        }]
       
        const reviewMaps = {
            applicantInformationMap,
            airInformationMap,
            principalBrokerInformationMap,
            companyTypeInformationMap,
            financialRecordsInformationMap,
            appointedAgentInformationMap,
            serviceAddressInformationMap,
            fiscalYearInformationMap,
            criminalRecordsCheckInformationMap,
            insuranceInformationMap,
            confirmationInformationMap,
            changeRequestDetailsMap,
            changeRequestNewAgentEmailMap,
            internalNotesMap,
            decisionMap
        }

        // const documentsContainingMaps = {
        //     insuranceInformationMap,
        //     criminalRecordsCheckInformationMap,
        //     airInformationMap
        // }
        // const updatedDocumentsNotAdded = parseNotAddedDocumentsInformation(applicationItem, documentsContainingMaps, documents);
       
        const updatedDocumentsNotAdded = parseUpdatedDocumentsInformation(applicationItem,documents);
        if(updatedDocumentsNotAdded?.length) {
            reviewMaps.updatedDocumentsMap = updatedDocumentsNotAdded
        }

        return reviewMaps
    }
    else if(brokerageApplication?.applicationStatus !== CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT && isHavingUpdatedDocuments(brokerageApplication)) { 
        applicationItem.reviewDataCollectionDebt = getUpdatedDocuemntsWithReviewData(applicationItem, documents, brokerageApplication.licenceStatus)
    }

    return applicationItem.reviewDataCollectionDebt 
}

export function bltMortgageBrokerReviewData(brokerApplication, brokerApplicationArchive, primaryApplication) {
    const applicationItem = brokerApplication.businessLicenceData
    const { documents } = brokerApplication

    if(isReviewDataNeeded(applicationItem)) {
        
        const isRenewal = isRenewalTypeApplication(brokerApplication)
        const isMainAgentApplication = isMortgageMainAgentTypeApplication(applicationTypeFromLicenceSubType(brokerApplication?.licencingSubType))
        
        let retObject = {}
        let applicantInformationMap = [{}]
        let brokerQualificationInformationMap = [{}]
        let brokerLicenceHistoryMap = [{}]
        let brokerEducationRequirementMap = [{}]
        let brokerCriminalRecordCheckMap = [{}]
        let brokerRegulatoryInformationMap = [{}]
        let brokerConfirmationInformationMap = [{}]
        let confirmationInformationMap = [{}]
        // let criminalRecordsCheckInformationMap = [{}]

        if(brokerApplication.applicationStatus === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT) {
            applicantInformationMap = parseCancelLicenceInformationMap(applicationItem, brokerApplication);
            retObject = {
                applicantInformationMap
            }
        }
        else if(isRenewal) {
            const applicationItemArchive = brokerApplicationArchive?.businessLicenceData
            applicantInformationMap = parsePrincipalBrokerInformationForRenewal(applicationItem, applicationItemArchive)
            brokerQualificationInformationMap = brokerQualificiationsInformationForRenewal(brokerApplication)
            brokerCriminalRecordCheckMap = brokerCriminalRecordCheckInformationForRenewal(brokerApplication,documents, brokerApplicationArchive)
            //brokerEducationRequirementMap = brokerEducationRequirementInformationForRenewal(applicationItem, documents)
            brokerEducationRequirementMap = brokerEducationContinuationRequirementInformationForRenewal(brokerApplication)
            brokerConfirmationInformationMap = brokerConfirmationInformationForRenewal(brokerApplication, primaryApplication)
           
            retObject = {
                applicantInformationMap,
                brokerQualificationInformationMap,
                brokerCriminalRecordCheckMap,
                brokerEducationRequirementMap,
                brokerConfirmationInformationMap
            }
            
        } else {
            applicantInformationMap = parsePrincipalBrokerInformation(applicationItem)
            
            brokerEducationRequirementMap = brokerEducationRequirementInformation(applicationItem, documents, brokerApplication?.cepRipExpiryDate)
            
            brokerRegulatoryInformationMap = brokerRegulatoryInformation(applicationItem, brokerApplication?.cepRipExpiryDate)

            retObject = {
                applicantInformationMap,
                brokerEducationRequirementMap,
                brokerRegulatoryInformationMap
            }

            const isComplianceOfficerChangeApp =
                brokerApplication.licencingSubType ===
                CONST.LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION ||
                brokerApplication.licencingSubType ===
                CONST.LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION;

            if(isMainAgentApplication) {
                if (isComplianceOfficerChangeApp) {
                    confirmationInformationMap =
                        parseComplianceOfficerConfirmationInformation(applicationItem);
                        brokerCriminalRecordCheckMap = brokerCriminalRecordCheckInformation(
                            brokerApplication?.licencingSubType,
                            applicationItem,
                            documents
                        );

                        retObject = {
                            ...retObject,
                            confirmationInformationMap,
                            brokerCriminalRecordCheckMap
                        };

                } else {
                    confirmationInformationMap = parseConfirmationInformation(applicationItem);
                    brokerLicenceHistoryMap = currentIndividualPrincipalBrokerInformation(
                        applicationItem,
                        documents
                    );
                    retObject = {
                        ...retObject,
                        brokerLicenceHistoryMap,
                        confirmationInformationMap,
                    };
                }
            } else { 
                brokerLicenceHistoryMap = currentMortgageBrokerLicenceInformation(applicationItem, documents)
                brokerCriminalRecordCheckMap = brokerCriminalRecordCheckInformation(brokerApplication.licencingSubType, applicationItem, documents)
                brokerConfirmationInformationMap = brokerConfirmationInformation(applicationItem, primaryApplication)
                retObject = {
                    ...retObject,
                    brokerLicenceHistoryMap,
                    brokerCriminalRecordCheckMap,
                    brokerConfirmationInformationMap
                }
            }
        }

        const decisionMap = [{
            adminDecision : "",
            review : ""
        }]
        const internalNotesMap = [{
            internalNotes : applicationItem.internalNotes,
            review : (applicationItem.internalNotes?.length > 0) ? "complete" : "" 
        }]

        // const documentsContainingObjects = {brokerCriminalRecordCheckMap, brokerLicenceHistoryMap, brokerEducationRequirementMap}
        // const updatedDocumentsNotAdded = parseNotAddedDocumentsInformation(applicationItem, documentsContainingObjects, documents);
        
        const updatedDocumentsNotAdded = parseUpdatedDocumentsInformation(applicationItem, documents);
        if(updatedDocumentsNotAdded?.length) {
            retObject.updatedDocumentsMap = updatedDocumentsNotAdded
        }

        return {
            ...retObject,
            internalNotesMap,
            decisionMap  
        }
    }
     else if(brokerApplication?.applicationStatus !== CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT && isHavingUpdatedDocuments(brokerApplication)) {
       applicationItem.reviewDataCollectionDebt = getUpdatedDocuemntsWithReviewData(applicationItem, documents, brokerApplication.licenceStatus)
    }  

    return applicationItem.reviewDataCollectionDebt 
}
